import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FiBell,
  FiLogOut,
  FiChevronDown,
  FiUser,
  FiSettings,
  FiHelpCircle,
  FiMenu,
} from "react-icons/fi";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../../../assets/all-images/logo.png";
import "./DashboardHeader.css";
import { getUserData } from "../../../hooks/Auth";

const DashboardHeader = ({ userRole, toggleSidebar }) => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(true);
  const navigate = useNavigate();
  const user = getUserData();
  const dropdownRef = useRef(null);
  const API_BASE_URL = "https://techcrew.pk/ulc/";


  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("isLoggedIn");
    navigate("/login");
  };

  const handleNotificationClick = () => {
    setHasUnreadNotifications(false);
  };

  return (
    <header className="dashboard-header">
      <div className="header-left">
        <motion.button
          className="mobile-menu-btn"
          onClick={toggleSidebar}
          whileTap={{ scale: 0.95 }}
        >
          <FiMenu className="menu-icon" />
        </motion.button>

        <Link to="/" className="logo-containerr">
          <motion.img
            src={logo}
            alt="United Limited Company"
            className="header-logoo"
            whileHover={{ rotate: [0, -5, 5, 0] }}
            transition={{ duration: 0.5 }}
          />
          {/* <span className="company-name">United Limited Company</span> */}
        </Link>
      </div>

      <div className="header-right">
        <motion.button
          className="notification-btn"
          onClick={handleNotificationClick}
          whileHover={{ y: -2 }}
          whileTap={{ scale: 0.95 }}
        >
          <FiBell className="icon" />
          {hasUnreadNotifications && (
            <motion.span
              className="notification-badge pulse"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0 }}
            >
              3
            </motion.span>
          )}
        </motion.button>

        <div
          className="profile-container"
          onClick={() => setIsProfileOpen(!isProfileOpen)}
          ref={dropdownRef}
        >
          <div className="profile-avatar">
            <img
              src={`${API_BASE_URL}${user?.user?.avatar}`}
              alt={user?.user?.name || "User"}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = `${API_BASE_URL}${user?.user?.avatar}`;
              }}
            />
          </div>
          <div className="profile-info">
            <span className="user-name">{user?.user?.name || "User"}</span>
            <span className="user-role">
              {user?.user?.role_display || userRole || "User"}
            </span>
          </div>
          <FiChevronDown
            className={`dropdown-icon ${isProfileOpen ? "open" : ""}`}
          />

          <AnimatePresence>
            {isProfileOpen && (
              <motion.div
                className="profile-dropdown"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.2, ease: "easeOut" }}
              >
                <div className="dropdown-header">
                  <div className="dropdown-avatar">
                    <img
                      src={`${API_BASE_URL}${user?.user?.profile_picture}`}
                      alt={user?.user?.name || "User"}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = logo;
                      }}
                    />
                  </div>
                  <div className="dropdown-user-info">
                    <h4>{user?.user?.name || "User"}</h4>
                    <p>{user?.user?.email || "No email"}</p>
                  </div>
                </div>
                <div className="dropdown-menu">
                  <Link
                    to="/profile"
                    className="dropdown-item"
                    onClick={() => setIsProfileOpen(false)}
                  >
                    <FiUser className="menu-icon" />
                    <span>My Profile</span>
                    <div className="hover-accent"></div>
                  </Link>
                  <Link
                    to="/settings"
                    className="dropdown-item"
                    onClick={() => setIsProfileOpen(false)}
                  >
                    <FiSettings className="menu-icon" />
                    <span>Settings</span>
                    <div className="hover-accent"></div>
                  </Link>
                  <Link
                    to="/help"
                    className="dropdown-item"
                    onClick={() => setIsProfileOpen(false)}
                  >
                    <FiHelpCircle className="menu-icon" />
                    <span>Help Center</span>
                    <div className="hover-accent"></div>
                  </Link>
                  <div className="dropdown-divider"></div>
                  <motion.button
                    className="dropdown-item logout"
                    onClick={handleLogout}
                    whileHover={{ x: 5 }}
                  >
                    <FiLogOut className="menu-icon" />
                    <span>Logout</span>
                    <div className="hover-accent"></div>
                  </motion.button>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
